/**
 * Versão e migrations do banco local do tablet.
 * Para evoluir o schema: acrescente uma entrada em MIGRATIONS com o
 * próximo `toVersion` e suba SCHEMA_VERSION. Nunca edite uma migration
 * já publicada — bancos em campo já a aplicaram.
 */

/** @type {{toVersion: number, statements: string[]}[]} */
export const MIGRATIONS = [
    {
        toVersion: 1,
        statements: [
            `CREATE TABLE IF NOT EXISTS outbox (
                seq          INTEGER PRIMARY KEY AUTOINCREMENT,
                evento_id    TEXT    NOT NULL UNIQUE,
                tipo         TEXT    NOT NULL,
                payload      TEXT    NOT NULL,
                criado_em    INTEGER NOT NULL,
                tentativas   INTEGER NOT NULL DEFAULT 0,
                estado       TEXT    NOT NULL DEFAULT 'pendente'
            )`,
            `CREATE INDEX IF NOT EXISTS idx_outbox_dreno
                ON outbox (estado, seq)`,
        ],
    },
];

export const SCHEMA_VERSION = MIGRATIONS[MIGRATIONS.length - 1].toVersion;
export const NOME_BANCO = 'fiat_arcade_tablet';
